var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForkandSpoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72656 16.9643C1.72656 17.5042 1.99953 18.022 2.48542 18.4038C2.97131 18.7855 3.63032 19 4.31747 19C5.00462 19 5.66363 18.7855 6.14952 18.4038C6.63541 18.022 6.90838 17.5042 6.90838 16.9643V9.5H1.72656V16.9643Z",
    fill: "#F8B117"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9531 16.9643C12.9531 17.5042 13.2261 18.022 13.712 18.4038C14.1979 18.7855 14.8569 19 15.544 19C16.2312 19 16.8902 18.7855 17.3761 18.4038C17.862 18.022 18.1349 17.5042 18.1349 16.9643V9.5H12.9531V16.9643Z",
    fill: "#F8B117"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90909 5.42969H5.18182V0.679688H3.45455V5.42969H1.72727V0.679688H0V6.78683H3.45455V8.82255H5.18182V6.78683H8.63636V0.679688H6.90909V5.42969Z",
    fill: "#F8B117"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5444 0C14.6282 0 13.7495 0.285969 13.1017 0.794996C12.4538 1.30402 12.0898 1.99441 12.0898 2.71429V4.75C12.0923 5.35024 12.348 5.9329 12.8168 6.40683C13.2856 6.88076 13.9411 7.21923 14.6808 7.36929V8.82143H16.408V7.36929C17.1477 7.21923 17.8032 6.88076 18.272 6.40683C18.7408 5.9329 18.9965 5.35024 18.9989 4.75V2.71429C18.9989 1.99441 18.635 1.30402 17.9871 0.794996C17.3393 0.285969 16.4606 0 15.5444 0Z",
    fill: "#F8B117"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkandSpoon);
export default __webpack_public_path__ + "static/media/ForkandSpoon.98ba8f68c22b8af9a6a04fb83386f581.svg";
export { ForwardRef as ReactComponent };